import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-final-form';

import {Link, SaveButton, TextField, Panel} from '../../common';
import {
  EMAIL_REGEXP,
} from '../../../configs/constants';
import {
  emailIdInvalid,
} from '../../../configs/messages';

export default class SignIn extends Component {
  static propTypes = {
    signInRequest: PropTypes.func.isRequired,
  };

  onFormSubmit = (values) => {
    const {signInRequest} = this.props;
    signInRequest(values);
  }

  validateEmail = (email = '') => {
    if (!email.match(EMAIL_REGEXP)) {
      return emailIdInvalid;
    }

    return null;
  }

  renderLink = () => (
    <Link to="/sign-up" theme="secondary" size="xs" type="button" text="Not registered?" icon="plus" className="button_rounded"/>
  );

  render() {
    return (
      <Panel
        title="Sign In"
        size="m"
        renderActions={this.renderLink()}
        cls="sign-in"
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          render={({handleSubmit, submitting}) => (
            <form className="form form_m" onSubmit={handleSubmit}>
              <TextField
                label="Email"
                name="email"
                inputType="email"
                maxLength={256}
                validatorsArray={[this.validateEmail]}
                required
              />
              <TextField
                label="Password"
                name="password"
                inputType="password"
                validatorsArray={[]}
                required
              />
              <div className="row row_gap_m">
                <Link to="/forgot-password" text="Forgot Password" className="sign-in__forgot-btn"/>
              </div>
              <div className="row row_center sign-in__actions">
                <SaveButton size="xl" type="submit" text="Sign In" disabled={submitting}/>
                <Link to="/sign-up" theme="secondary" size="xl" type="button" text="Not registered?" className="sign-in__register-btn"/>
              </div>
            </form>
          )}
        />
      </Panel>
    );
  }
}
